import store from "../store";
import Vue from 'vue'

export default async function permissions({ to, next, router }) {
    if (!store.getters.isAuthenticated) {
        return router.push({ name: "Login" });
    }

    let me;
    try {
        await store.dispatch("profile/me");
        me = await store.getters["profile/me"];
        let agencia = me.relationships.agencias.data.find(item => item.attributes.nombre == me.attributes.agencia_activa);
        
        if(agencia == undefined){
            Vue.prototype.$notify({
                        type: "danger",
                        message: 'Se detecto un error en la agencia activa, es necesario volver a iniciar sesión.',
                        duration: -1
                    });
            await store.dispatch("logout");
            return router.push({ path: "/login" });
        }

        if(to.name != 'Dashboard' && me.attributes.agencia_activa == null){
            Vue.prototype.$notify({
                        type: "danger",
                        message: 'Se detecto un error en la agencia activa, es necesario volver a iniciar sesión.',
                        duration: -1
                    });
            await store.dispatch("logout");
            return router.push({ path: "/login" });
        }
    } catch {
        await store.dispatch("logout");
        return next({ name: "Login" });
    }

    const permission = to.path.split('/');
    const permissionFinal = permission[permission.length-1];

    //recorre permisos y checa si la segunda palabra del nombre coincide con la ruta
    for(let i = 0; i < me.relationships.permissions.length; i++){
        let permissions = me.relationships.permissions[i].name.split(' ');
        if (permissions[1] === permissionFinal || permissions[2] === permissionFinal) {
            return next();
        }
    }
    
    return router.push({ path: "/dashboard" });
}
